import React, { useState, useEffect } from "react";
//
import {
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Typography,
} from "@material-ui/core";
import { useForm, FormProvider } from "react-hook-form";
import { Link } from "react-router-dom";

//
import { commerce } from "../../lib/commerce";
import FormInput from "./FormInput";
//
//
import useStyles from "./styles_addressForm";
//
const AddressForm = ({ checkoutToken, next }) => {
  //
  //
  const classes = useStyles();

  //

  const [shippingCountries, setShippingCountries] = useState([]);
  const [shippingCountry, setShippingCountry] = useState("");
  const [shippingSubdivisions, setShippingSubdivisions] = useState([]);
  const [shippingSubdivision, setShippingSubdivision] = useState("");
  const [shippingOptions, setShippingOptions] = useState([]);
  const [shippingOption, setShippingOption] = useState("");
  const methods = useForm();
  //
  /*

                ARRAY CONVERTER countries

*/
  const countries = Object.entries(shippingCountries).map(([code, name]) => ({
    id: code,
    label: name,
  }));
  // console.log(countries);
  //
  /*

                ARRAY CONVERTER Subdivisions

*/
  const subdivisions = Object.entries(shippingSubdivisions).map(
    ([code, name]) => ({
      id: code,
      label: name,
    })
  );
  /*                  OPTIONS

                This is an array by default
                so no need for conversion

*/
  const options = shippingOptions.map((sO) => ({
    id: sO.id,
    label: `${sO.description} ~ (${sO.price.formatted_with_symbol}) `,
  }));
  //
  // console.log(options);
  //
  //-------------
  //
  //
  //
  //FETCH COUNTRIES
  const fetchShippingCountries = async (checkoutTokenId) => {
    const { countries } = await commerce.services.localeListShippingCountries(
      checkoutTokenId
    );

    setShippingCountries(countries);
    // we get the keys out of the countries with the help of the: Object.keys
    setShippingCountry(Object.keys(countries)[0]);
  };
  //
  //-------------
  //
  //
  //
  // FETCH SUBDIVISIONS
  const fetchSubdivisions = async (countryCode) => {
    const { subdivisions } = await commerce.services.localeListSubdivisions(
      countryCode
    );
    // plural
    setShippingSubdivisions(subdivisions);
    //1 we get the keys out of the subdivisions with the help of the: Object.keys
    // individual subdivision
    setShippingSubdivision(Object.keys(subdivisions)[0]); //2 and then we get the first element [0])
  };

  //-------------
  //
  //
  // FETCH OPTIONS
  const fetchShippingOptions = async (
    checkoutTokenId,
    country,
    region = null
  ) => {
    const options = await commerce.checkout.getShippingOptions(
      checkoutTokenId,
      { country, region }
    );

    setShippingOptions(options);
    setShippingOption(options[0].id);
  };
  //
  //
  //
  //
  //
  // Countries
  useEffect(() => {
    fetchShippingCountries(checkoutToken.id);
    // This worked for me
    return () => {
      setShippingCountries({}); // This worked for me
    };
  }, [checkoutToken.id]);

  //
  //
  //Subdivisions
  useEffect(() => {
    if (shippingCountry) fetchSubdivisions(shippingCountry);
  }, [shippingCountry]);

  //
  // Options
  useEffect(() => {
    if (shippingSubdivision)
      fetchShippingOptions(
        checkoutToken.id,
        shippingCountry,
        shippingSubdivision
      );
  }, [shippingSubdivision, checkoutToken.id, shippingCountry]);

  //
  //
  //

  return (
    <>
      <Typography
        variant="h6"
        gutterBottom
        className={classes.titleAddressForm}
      >
        Shipping Address
      </Typography>
      {/* FORM */}
      <FormProvider {...methods}>
        <form
          className={classes.addressFormStyle}
          onSubmit={methods.handleSubmit((data) =>
            next({
              ...data,
              shippingCountry,
              shippingSubdivision,
              shippingOption,
            })
          )}
        >
          <Grid container spacing={3}>
            <FormInput name="firstName" label="First name" />
            <FormInput name="lastName" label="Last name" />
            <FormInput name="address1" label="Address line 1" />
            <FormInput name="email" label="Email" />
            <FormInput name="city" label="City" />
            <FormInput name="zip" label="Zip / Postal code" />
            {/* ------------ */}
            {/* ------------ */}
            <Grid item xs={12} sm={6}>
              <InputLabel>Shipping Country</InputLabel>
              <Select
                value={shippingCountry}
                fullWidth
                onChange={(e) => setShippingCountry(e.target.value)}
              >
                {countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputLabel>Shipping Subdivision</InputLabel>
              <Select
                value={shippingSubdivision}
                fullWidth
                onChange={(e) => setShippingSubdivision(e.target.value)}
              >
                {subdivisions.map((subdivision) => (
                  <MenuItem key={subdivision.id} value={subdivision.id}>
                    {subdivision.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputLabel>Shipping Options</InputLabel>
              <Select
                value={shippingOption}
                fullWidth
                onChange={(e) => setShippingOption(e.target.value)}
              >
                {options.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          {/* 
          
          */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexFlow: "row wrap",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            {/* 
            
            
            BUTTONS
            
            */}
            <Button
              component={Link}
              to="/cart"
              className={classes.buttonBackToCart}
            >
              Back to Cart
            </Button>
            {/* blue button */}
            <Button
              type="submit"
              variant="contained"
              className={classes.buttonAddressForm}
            >
              Next
            </Button>
          </div>

          {/* 
          
          */}
        </form>
      </FormProvider>
    </>
  );
};

export default AddressForm;
